
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93UKZVTSy6mHjEWz64t_45w1e3D_45jjd3F00kJkyY7Y7U5eQMeta } from "/codebuild/output/src2089535083/src/ark/pages/[...slug].vue?macro=true";
import { default as guiasxOcKbJeKcsXh_45RJvyjki5Jtov2xy6ggTX2cvrYB2BboMeta } from "/codebuild/output/src2089535083/src/ark/pages/blog/guias.vue?macro=true";
import { default as indexHs2trG2YhOJDQvIENxlfNTStJX2xDbfERlbU0yXhwTYMeta } from "/codebuild/output/src2089535083/src/ark/pages/blog/index.vue?macro=true";
import { default as temasMncofUzf3G1YzHUdadr_45wcRRazvoedfCpmEYAeL68t8Meta } from "/codebuild/output/src2089535083/src/ark/pages/blog/temas.vue?macro=true";
import { default as pesquisaH4J2tFpi7IMv5sugfA4dFWKg2dhak_45JY2WnrD_8VR_45gMeta } from "/codebuild/output/src2089535083/src/ark/pages/blog/pesquisa.vue?macro=true";
import { default as moradaJMo6rDyN7CpMgauMOU33ugAEX3LpbglVByXRnMlEtZ8Meta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue?macro=true";
import { default as habitantesHN5aSmC_SFT9obQ9WwfyRwfw_45J_qK9dsP2zm7Zh5NBIMeta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue?macro=true";
import { default as escalao_45gaszDkcMJDHUDZbgEMXUrhdqpQUu1Db_8qTPWQuFCC4cYQMeta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue?macro=true";
import { default as tempo_45em_45casarfiVzWkfY6UxhPnG2b_45DyOfXvTYRyFTeMjKmZPGfx10Meta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue?macro=true";
import { default as tipo_45de_45produtov5VU1rCwKqUl2ynfGxmWsbiWWSLUJIjcp92tT9dfvVsMeta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue?macro=true";
import { default as comercializadora3pYY6wUIil2fx6rkFJmz13WfIE0E94D6itgg6V0KTTUMeta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue?macro=true";
import { default as dados_45de_45contacto0bv0PxqcqRfq4RNx8E_450Oxbs8PspE5PQ_45FSjHYoYMFsMeta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue?macro=true";
import { default as potencia_45contratadaig_45w_45cv1jp91wXcjWO1lakS8cm81rEsRkYiXjssqfDkMeta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue?macro=true";
import { default as simularLSucEns_jqgCsrSC0ORGYm5bWpQJWUhTXNz6TutVXkoMeta } from "/codebuild/output/src2089535083/src/ark/pages/energia/simular.vue?macro=true";
import { default as internetaCQkUmSkNV0ACUpf7NFMB86llNVn0bIneqGSjhy4bckMeta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue?macro=true";
import { default as telemovelZad_Ds87TAKzg46Ib4JNO6fbfUj31gAkIVwx7yHGRdAMeta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue?macro=true";
import { default as fidelizacaoIhkLumoY1SyuyCs_45XaL1NtFbyI5M_45irjoeTjYn9CX94Meta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue?macro=true";
import { default as operadora_45atualfH_45lnytNewfaVpBIP5DVWjHWwGsiscbgM_456WmEpY1dwMeta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue?macro=true";
import { default as dados_45de_45contactoVsGvq8LhOw4XnXyqsH0AWeTFNOYwlMgf8mMwCqVEoGQMeta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue?macro=true";
import { default as simularEe5Um9e_yyPgjoSJgO071dNd244tXURQ_g_1_nxjtnUMeta } from "/codebuild/output/src2089535083/src/ark/pages/tv-net-voz/simular.vue?macro=true";
import { default as _91_46_46_46slug_93A2U_45L43_45m4yeK_45xEfoZD2dZKrFh4n9_RayRKlmEWKZEMeta } from "/codebuild/output/src2089535083/src/ark/pages/blog/autor/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93_45NM6CZgBbpqywlKR8SRy4OShmlDxGzdoNYo1kfL1KukMeta } from "/codebuild/output/src2089535083/src/ark/pages/blog/rubricas/[...slug].vue?macro=true";
import { default as resumo86bDl6oN8X7GXLaR8RSsjfd4OO8zb7iIuffJ9HHyZkUMeta } from "/codebuild/output/src2089535083/src/ark/pages/depositos-a-prazo/resumo.vue?macro=true";
import { default as finalidadeUfrU_A02h665HngFwuYc96q_45f41sdFtlpUdiITEs_45dYMeta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue?macro=true";
import { default as tipo_45de_45taxav2U_45YcV9VvAmMjolwXxOsV2KkMbKaQ1F7MzwcUDn7jkMeta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue?macro=true";
import { default as dados_45de_45contactobTKDooZluIQlG4ArdZ2VnpzOVaLTJ1jvVBc31a1U8v0Meta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue?macro=true";
import { default as estado_45do_45processomQ_45aJS4zMXS_4eve_aa3WI8CabmGnb9jHfOlkIkYnUgMeta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue?macro=true";
import { default as situacao_45financeiraXK2S_45dYNq21f64GStXOVPMsj_0tiFU91e9UBvUUqMc4Meta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue?macro=true";
import { default as montante_45do_45emprestimoB47yOM1tf0eBWpP6zNJnHOS_456DuxhZWkaFGSbrK5Q8YMeta } from "/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue?macro=true";
import { default as simularHHkgB__g371BuKKmeaOQbvpqtsllfK_gIMO9SbGE0uUMeta } from "/codebuild/output/src2089535083/src/ark/pages/credito-habitacao/simular.vue?macro=true";
import { default as _91_46_46_46slug_93VbxS4GR0jhBlPg9Grm4dFlFq61C3Z_45_45Z086jyUS_HgcMeta } from "/codebuild/output/src2089535083/src/ark/pages/simuladores/embed/[...slug].vue?macro=true";
import { default as resultadoslk2eCoe4jDNwzhfs6VKbw6NpIyo6GksiStaZG4Nm_2sMeta } from "/codebuild/output/src2089535083/src/ark/pages/credito-habitacao/resultados.vue?macro=true";
import { default as indexGmoxKSuQK_45OKIhoF1eWQNwaVW5Pn07Q0NclrR8MViIMMeta } from "/codebuild/output/src2089535083/src/ark/pages/parcerias-imobiliarias/index.vue?macro=true";
import { default as _91_46_46_46slug_93P32PBUUbcX_45RupfhkfmcvzVDmXnd9LLXSQ90ehbLyPIMeta } from "/codebuild/output/src2089535083/src/ark/pages/tv-net-voz/campanhas/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93AGDAW2NxB0fBghZ7QqFu7VhVoo3BS6t8Q_Ac90jrg1gMeta } from "/codebuild/output/src2089535083/src/ark/pages/parcerias-imobiliarias/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/[...slug].vue")
  },
  {
    name: "blog-guias",
    path: "/blog/guias",
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/blog/guias.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/blog/index.vue")
  },
  {
    name: "blog-temas",
    path: "/blog/temas",
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/blog/temas.vue")
  },
  {
    name: "blog-pesquisa",
    path: "/blog/pesquisa",
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/blog/pesquisa.vue")
  },
  {
    name: "energia-simular",
    path: "/energia/simular",
    meta: { ...(simularLSucEns_jqgCsrSC0ORGYm5bWpQJWUhTXNz6TutVXkoMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/energia/simular.vue"),
    children: [
  {
    name: "energia-simular-morada",
    path: "morada",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue")
  },
  {
    name: "energia-simular-habitantes",
    path: "habitantes",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue")
  },
  {
    name: "energia-simular-escalao-gas",
    path: "escalao-gas",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue")
  },
  {
    name: "energia-simular-tempo-em-casa",
    path: "tempo-em-casa",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue")
  },
  {
    name: "energia-simular-tipo-de-produto",
    path: "tipo-de-produto",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue")
  },
  {
    name: "energia-simular-comercializadora",
    path: "comercializadora",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue")
  },
  {
    name: "energia-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue")
  },
  {
    name: "energia-simular-potencia-contratada",
    path: "potencia-contratada",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue")
  }
]
  },
  {
    name: "tv-net-voz-simular",
    path: "/tv-net-voz/simular",
    meta: { ...(simularEe5Um9e_yyPgjoSJgO071dNd244tXURQ_g_1_nxjtnUMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/tv-net-voz/simular.vue"),
    children: [
  {
    name: "tv-net-voz-simular-internet",
    path: "internet",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue")
  },
  {
    name: "tv-net-voz-simular-telemovel",
    path: "telemovel",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue")
  },
  {
    name: "tv-net-voz-simular-fidelizacao",
    path: "fidelizacao",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue")
  },
  {
    name: "tv-net-voz-simular-operadora-atual",
    path: "operadora-atual",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue")
  },
  {
    name: "tv-net-voz-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue")
  }
]
  },
  {
    name: "blog-autor-slug",
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/blog/autor/[...slug].vue")
  },
  {
    name: "blog-rubricas-slug",
    path: "/blog/rubricas/:slug(.*)*",
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/blog/rubricas/[...slug].vue")
  },
  {
    name: "depositos-a-prazo-resumo",
    path: "/depositos-a-prazo/resumo",
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/depositos-a-prazo/resumo.vue")
  },
  {
    name: "credito-habitacao-simular",
    path: "/credito-habitacao/simular",
    meta: { ...(simularHHkgB__g371BuKKmeaOQbvpqtsllfK_gIMO9SbGE0uUMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/credito-habitacao/simular.vue"),
    children: [
  {
    name: "credito-habitacao-simular-finalidade",
    path: "finalidade",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue")
  },
  {
    name: "credito-habitacao-simular-tipo-de-taxa",
    path: "tipo-de-taxa",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue")
  },
  {
    name: "credito-habitacao-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue")
  },
  {
    name: "credito-habitacao-simular-estado-do-processo",
    path: "estado-do-processo",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue")
  },
  {
    name: "credito-habitacao-simular-situacao-financeira",
    path: "situacao-financeira",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue")
  },
  {
    name: "credito-habitacao-simular-montante-do-emprestimo",
    path: "montante-do-emprestimo",
    component: () => import("/codebuild/output/src2089535083/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue")
  }
]
  },
  {
    name: "simuladores-embed-slug",
    path: "/simuladores/embed/:slug(.*)*",
    meta: _91_46_46_46slug_93VbxS4GR0jhBlPg9Grm4dFlFq61C3Z_45_45Z086jyUS_HgcMeta || {},
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/simuladores/embed/[...slug].vue")
  },
  {
    name: "credito-habitacao-resultados",
    path: "/credito-habitacao/resultados",
    meta: resultadoslk2eCoe4jDNwzhfs6VKbw6NpIyo6GksiStaZG4Nm_2sMeta || {},
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/credito-habitacao/resultados.vue")
  },
  {
    name: "parcerias-imobiliarias",
    path: "/parcerias-imobiliarias",
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/parcerias-imobiliarias/index.vue")
  },
  {
    name: "tv-net-voz-campanhas-slug",
    path: "/tv-net-voz/campanhas/:slug(.*)*",
    meta: _91_46_46_46slug_93P32PBUUbcX_45RupfhkfmcvzVDmXnd9LLXSQ90ehbLyPIMeta || {},
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/tv-net-voz/campanhas/[...slug].vue")
  },
  {
    name: "parcerias-imobiliarias-slug",
    path: "/parcerias-imobiliarias/:slug(.*)*",
    meta: _91_46_46_46slug_93AGDAW2NxB0fBghZ7QqFu7VhVoo3BS6t8Q_Ac90jrg1gMeta || {},
    component: () => import("/codebuild/output/src2089535083/src/ark/pages/parcerias-imobiliarias/[...slug].vue")
  }
]